"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSimplePadding = void 0;
function getSimplePadding(padding, minPadding) {
    var _a, _b;
    if (minPadding === void 0) { minPadding = 0; }
    if (typeof padding === 'number') {
        var adjustedPadding = Math.max(minPadding, padding);
        return {
            inner: adjustedPadding,
            outer: adjustedPadding,
        };
    }
    return {
        inner: Math.max(minPadding, (_a = padding === null || padding === void 0 ? void 0 : padding.inner) !== null && _a !== void 0 ? _a : 0),
        outer: Math.max(minPadding, (_b = padding === null || padding === void 0 ? void 0 : padding.outer) !== null && _b !== void 0 ? _b : 0),
    };
}
exports.getSimplePadding = getSimplePadding;
//# sourceMappingURL=dimensions.js.map